import React from "react";
import "../../style_components/Loading.css";

export default function Loading() {
  return (
    <div className="container-loading">
      {/* <div className="box">
        <span></span> */}
      <img className="loading-image" src="/Gracie Trans Logo.png" />
      <div className="loading-text">Loading...</div>
      {/* </div> */}
    </div>
  );
}
